import type { TFunction } from 'i18next';
import type { ReactNode } from 'react';
import {
  Home,
  Router,
  Wrench,
  Settings,
  Sliders,
  FileInput,
  Map,
  Users,
  Boxes,
  ShieldCheck,
  ClipboardList,
} from 'lucide-react';

type MenuItem = {
  path?: string;
  icon: ReactNode;
  label: string;
  submenu?: MenuItem[];
};

export const menuItems = (t: TFunction, role?: string): MenuItem[] => {
  const items: MenuItem[] = [
    {
      path: '/dashboard',
      icon: <Home size={24} />,
      label: t('breadcrumbs.dashboard'),
    },
    {
      path: '/list',
      icon: <Router size={24} />,
      label: t('breadcrumbs.equipment'),
    },
    {
      path: '/tools',
      icon: <Wrench size={24} />,
      label: t('breadcrumbs.tools'),
    },
    { path: '/map', icon: <Map size={24} />, label: t('breadcrumbs.map') },
    {
      path: '/reports',
      icon: <ClipboardList size={24} />,
      label: t('breadcrumbs.reports'),
    },
  ];

  if (role === 'ADMIN') {
    items.push({
      icon: <Settings size={24} />,
      label: t('breadcrumbs.settings'),
      submenu: [
        {
          path: '/settings/variables',
          icon: <Sliders size={18} />,
          label: t('breadcrumbs.variables'),
        },
        {
          path: '/settings/standardValues',
          icon: <Boxes size={18} />,
          label: t('breadcrumbs.standardValues'),
        },
        {
          path: '/settings/parameters',
          icon: <Sliders size={18} />,
          label: t('breadcrumbs.parameters'),
        },
        // {
        //   path: '/settings/automations',
        //   icon: <RefreshCcw size={18} />,
        //   label: t('breadcrumbs.automations'),
        // },
        {
          path: '/settings/users',
          icon: <Users size={18} />,
          label: t('breadcrumbs.users'),
        },
        {
          path: '/settings/files',
          icon: <FileInput size={18} />,
          label: t('breadcrumbs.files'),
        },
        {
          path: '/settings/models',
          icon: <Router size={18} />,
          label: t('breadcrumbs.models'),
        },
        {
          path: '/settings/homologation',
          icon: <ShieldCheck size={18} />,
          label: t('breadcrumbs.homologation'),
        },
        {
          path: '/settings/reports',
          icon: <ClipboardList size={18} />,
          label: t('breadcrumbs.reports'),
        },
      ],
    });
  }

  return items;
};
